// extracted by mini-css-extract-plugin
module.exports = {"idRenderContainer":"Punk_idRenderContainer__2rfVv","imageContainer":"Punk_imageContainer__26x36","openSeaAnchor":"Punk_openSeaAnchor__15eNl"};